import classes from "../styles/Footer.module.css";
// import MainNavigation from "./MainNavigation";

function Footer() {
  return (
    <div className={classes.containers}>
      <div className={classes.footer}>
      </div>
    </div>
  );
}

export default Footer;
